import { useEffect } from 'react';

export function Meta({ subtitle }) {
  useEffect(() => {
    document.title = `${subtitle} | Raw 2`;
  }, [subtitle]);

  return null;
}
